/* DIBAMEX Delivery Times v2.7.1
 * - Producto leído desde data-product (más seguro, sin XSS)
 * - Corte 12:00 PM America/Tijuana
 * - Stock por variante 100% del Product JSON
 * - Detección robusta de variant id + listeners + polling + observer
 * - Interlineado compacto
 */

(function(){
  if (window.DIBAMEXDeliveryLoaded) return; window.DIBAMEXDeliveryLoaded = true;

  var ID='delivery-time-container';
  var MS=60000, DBG=false;
  var EVTS=['theme:variant:change','variant:changed','product:variant-change','shopify:section:load','page:load','theme:loaded'];
  var PSTYLE='margin:2px 0;line-height:1.35;';

  // ---------- Utils ----------
  function $(id){ return document.getElementById(id); }
  function q(sel,root){ return (root||document).querySelector(sel); }
  function qa(sel,root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function log(){ if(DBG) console.log('[DIBAMEXDelivery]', ...arguments); }
  function getDebugFlag(){
    try{
      if(location.search.includes('debugDelivery=1')) return true;
      if(localStorage && localStorage.DIBAMEX_DEBUG==='1') return true;
      var el=$(ID); if(el && (el.dataset.debug==='1'||el.dataset.debug==='true')) return true;
    }catch(_){}
    return false;
  }
  function isVisible(el){
    if(!el) return false;
    if(el.offsetParent===null && el.getClientRects().length===0) return false;
    var cs = window.getComputedStyle(el);
    return cs.display!=='none' && cs.visibility!=='hidden' && parseFloat(cs.opacity||'1')>0;
  }

  // ---------- TZ / fechas ----------
  function nowInTZ(tz){
    var now=new Date();
    var tzDate=new Date(now.toLocaleString('en-US',{timeZone:tz}));
    var localDate=new Date(now.toLocaleString('en-US'));
    return new Date(now.getTime()+(tzDate.getTime()-localDate.getTime()));
  }
  function nextBusinessDay(d){
    var c=new Date(d); c.setDate(c.getDate()+1);
    while(c.getDay()===6||c.getDay()===0) c.setDate(c.getDate()+1);
    return c;
  }
  function addBusinessDays(d,days){
    var c=new Date(d),i=0;
    while(i<days){ c.setDate(c.getDate()+1); var w=c.getDay(); if(w!==6&&w!==0) i++; }
    return c;
  }
  function fmt(d){ return d.toLocaleDateString('es-MX',{day:'numeric',month:'long'}); }
  function minutesUntilCutoff(tz,hhmm){
    var now=nowInTZ(tz);
    var parts=(hhmm||'12:00').split(':'), h=parseInt(parts[0],10)||0, m=parseInt(parts[1],10)||0;
    var cut=new Date(now); cut.setHours(h,m,0,0);
    if(now>=cut){ var nx=nextBusinessDay(now); cut=new Date(nx); cut.setHours(h,m,0,0); }
    var diff=Math.ceil((cut-now)/MS);
    if(diff<=0){ var nx2=nextBusinessDay(now); var cut2=new Date(nx2); cut2.setHours(h,m,0,0); diff=Math.max(1,Math.ceil((cut2-now)/MS)); }
    return diff;
  }
  function human(min){ if(min<=1)return'1 minuto'; if(min<60)return min+' minutos'; var h=Math.floor(min/60),r=min%60; return r?(h+' hora'+(h>1?'s':'')+' '+r+' minutos'):(h+' hora'+(h>1?'s':'')); }

  // ---------- Product JSON / variante ----------
  var _productCache = null;
  function productJSON(){
    if(_productCache) return _productCache;
    try{
      var el=$(ID);
      if(el && el.dataset.product){
        _productCache = JSON.parse(el.dataset.product);
        return _productCache;
      }
      return window.__DIBAMEX_PRODUCT__ || window.product || null;
    }catch(e){ log('Error parseando product JSON', e); return null; }
  }
  function findVariantById(id){
    var p=productJSON(); if(!p||!Array.isArray(p.variants)) return null;
    return p.variants.find(v=>String(v.id)===String(id))||null;
  }

  function currentVariantId(){
    var m=location.search.match(/[?&]variant=(\d+)/);
    if(m && m[1]) return m[1];

    var inputs = qa('form[action*="/cart/add"] input[name="id"]')
      .filter(el=>el && el.value && isVisible(el.closest('form')));
    if(inputs.length){ return inputs[inputs.length-1].value; }

    var el = q('[data-variant-id]'); if(el && el.dataset.variantId) return el.dataset.variantId;

    return '';
  }

  function atcDisabled(){
    var btn = q('form[action*="/cart/add"] [name="add"]');
    if(!btn || !isVisible(btn)) return null;
    var t=(btn.textContent||'').toLowerCase();
    if(btn.disabled) return true;
    if(/agotad|sold\s*out|no disponible/.test(t)) return true;
    return false;
  }

  // ---------- Precio ----------
  function toCentsFromText(t){
    if(!t) return 0;
    t=String(t).replace(/\s/g,'').replace(/[^0-9.,]/g,'');
    if(!t) return 0;
    var lastComma=t.lastIndexOf(','), lastDot=t.lastIndexOf('.');
    var sep=Math.max(lastComma,lastDot);
    if(sep>-1){
      var intPart=t.slice(0,sep).replace(/[^\d]/g,'')||'0';
      var decPart=t.slice(sep+1).replace(/[^\d]/g,'').slice(0,2).padEnd(2,'0');
      return (parseInt(intPart,10)||0)*100 + (parseInt(decPart,10)||0);
    }
    return (parseInt(t.replace(/[^\d]/g,'')||'0',10)||0)*100;
  }
  function priceFromDOMorData(){
    var el=$(ID);
    if(el){
      var dpc=el.getAttribute('data-price-cents');
      if(dpc){ var c=parseInt(dpc,10); if(c>0) return c; }
    }
    var nodes=[
      '#product-price','[data-product-price]','.product__price .price-item--regular',
      '.price__regular .price-item--regular','.price-item--sale','.product__price .price__current','.price .price__current'
    ];
    for(var i=0;i<nodes.length;i++){
      var n=q(nodes[i]); if(!n||!isVisible(n)) continue;
      if(n.dataset && (n.dataset.productPriceCents||n.dataset.productPrice)){
        var v=parseInt(n.dataset.productPriceCents||'0',10);
        if(!v && n.dataset.productPrice) v=Math.round(parseFloat(n.dataset.productPrice)*100);
        if(v>0) return v;
      }
      var cents=toCentsFromText(n.textContent); if(cents>0) return cents;
    }
    return 0;
  }

  // ---------- Config ----------
  function readCfg(){
    var el=$(ID); if(!el) return null;
    var stockAttr=(el.dataset.stock||'').toLowerCase();
    var initialStock = stockAttr ? !(stockAttr.includes('out')||stockAttr==='0'||stockAttr==='false') : undefined;
    return {
      el,
      tz: el.dataset.tz || 'America/Tijuana',
      cutoff: el.dataset.cutoff || '12:00',
      free: parseInt(el.dataset.freeThresholdCents||'99900',10),
      terrestre: (el.dataset.terrestre||'4,7').split(',').map(n=>parseInt(n,10)),
      aereo:     (el.dataset.aereo||'3,4').split(',').map(n=>parseInt(n,10)),
      wa: el.dataset.whatsapp || '5216862352697',
      _price: 0,
      _inStock: initialStock,
      _variantId: '',
      get price(){ return this._price||0; },
      set price(v){ this._price=(v|0); },
      get inStock(){ return (typeof this._inStock==='boolean')? this._inStock : true; },
      set inStock(v){ this._inStock=!!v; }
    };
  }

  function refreshFromVariant(cfg){
    var vid = currentVariantId(); if(!vid) { log('variantId vacío'); return; }
    cfg._variantId = vid;
    var v = findVariantById(vid);
    if(v){
      cfg.price   = v.price||0;
      cfg.inStock = !!v.available;
    }else{
      var dis=atcDisabled(); if(dis!==null) cfg.inStock=!dis;
      if(!cfg.price) cfg.price=priceFromDOMorData();
    }
  }

  // ---------- Render ----------
  function renderOOS(cfg){
    var c=cfg.el;
    var msg=encodeURIComponent('Hola, estoy interesado en hacer una orden sobre pedido.\n'+location.href);
    c.innerHTML =
      '<p style="'+PSTYLE+'">📦 <strong>Ordénalo sobre pedido a <a href="mailto:ventas@dibamex.com" style="color:#1D2D49;text-decoration:underline;font-weight:600;">ventas@dibamex.com</a></strong></p>'
      +'<p style="'+PSTYLE+'">o <a href="https://wa.me/'+cfg.wa+'?text='+msg+'" target="_blank" rel="noopener" style="color:#C3D82D;font-weight:bold;text-decoration:none;">solicítalo por WhatsApp</a></p>';
    c.style.display='block';
  }

  function render(cfg){
    if(!cfg||!cfg.el) return;

    refreshFromVariant(cfg);
    if(!cfg.inStock){ renderOOS(cfg); return; }

    if(!cfg.price){
      cfg.price = priceFromDOMorData();
      if(!cfg.price){
        cfg.el.innerHTML='<p style="'+PSTYLE+'">📦 Calculando entrega…</p>';
        cfg.el.style.display='block';
        return;
      }
    }

    var today=nextBusinessDay(nowInTZ(cfg.tz));
    var tMin=cfg.terrestre[0], tMax=cfg.terrestre[1];
    var aMin=cfg.aereo[0],     aMax=cfg.aereo[1];
    var terI=addBusinessDays(new Date(today),tMin), terF=addBusinessDays(new Date(today),tMax);
    var airI=addBusinessDays(new Date(today),aMin), airF=addBusinessDays(new Date(today),aMax);
    var mins=minutesUntilCutoff(cfg.tz,cfg.cutoff);
    var terrestreTxt=(cfg.price>=cfg.free?'🚚 <strong>Envío Gratis Terrestre</strong>':'🚚 <strong>Envío Terrestre</strong>')
                    +': entre el '+fmt(terI)+' y '+fmt(terF)+'.';

    cfg.el.innerHTML=
      '<p style="'+PSTYLE+'">📦 <strong>Ordena antes de '+human(mins)+'</strong> para que tu pedido lo recibas:</p>'
      +'<p style="'+PSTYLE+'">'+terrestreTxt+'</p>'
      +'<p style="'+PSTYLE+'">✈️ <strong>Envío Aéreo:</strong> entre el '+fmt(airI)+' y '+fmt(airF)+'.</p>';

    cfg.el.style.display='block';
  }

  // ---------- Listeners + polling + observer ----------
  var lastVid='';

  function handleVariantEvent(cfg, detailVariant){
    if(detailVariant){
      cfg._variantId = String(detailVariant.id||'');
      cfg.price      = detailVariant.price||0;
      cfg.inStock    = !!detailVariant.available;
    }
    render(cfg);
  }

  function bindVariantListeners(cfg){
    EVTS.forEach(function(n){ document.addEventListener(n, function(e){ handleVariantEvent(cfg, e && e.detail && e.detail.variant); }); });

    document.addEventListener('change', function(ev){
      var t=ev.target;
      if(!t) return;
      if(t.matches('select[name="id"], input[name="id"], [name^="options"], .single-option-selector')){
        setTimeout(function(){ handleVariantEvent(cfg, null); }, 40);
      }
    });

    setInterval(function(){
      var vid=currentVariantId();
      if(vid && vid!==lastVid){
        lastVid=vid;
        handleVariantEvent(cfg, null);
      }
    }, 250);
  }

  function startObserver(cfg){
    var mo=new MutationObserver(function(){
      var el=$(ID);
      if(!el || (el.style.display==='none' && el.innerHTML==='')){ init(true); return; }
      var btn=q('form[action*="/cart/add"] [name="add"]');
      var priceNode=q('.product__price, .price, #product-price, [data-product-price]');
      if(btn||priceNode) { clearTimeout(startObserver._t); startObserver._t=setTimeout(function(){ render(cfg); }, 80); }
    });
    mo.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','data-variant-id','data-product-price','data-product-price-cents']});
  }

  // ---------- Init ----------
  function init(force){
    DBG=getDebugFlag();
    var cfg=readCfg(); if(!cfg) return;
    if(force) setTimeout(function(){ render(cfg); }, 20);
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ render(cfg); });
    else render(cfg);
    setTimeout(function(){ render(cfg); }, 120);
    bindVariantListeners(cfg);
    startObserver(cfg);
  }

  window.DIBAMEXDelivery={ init:init, version:'2.7.1' };

  if(document.readyState==='complete'||document.readyState==='interactive') init(false);
  else document.addEventListener('DOMContentLoaded', function(){ init(false); });

})();